/**
 * Copies the code in [data-code] to the clipboard and briefly swaps the button label.
 */
class CopyCode extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const button = this.querySelector('button');
    const label = this.querySelector('[data-copy-label]');
    const original = label?.textContent || '';
    button?.addEventListener('click', async () => {
      const code = this.dataset.code || '';
      try {
        await navigator.clipboard.writeText(code);
      } catch {
        const field = document.createElement('textarea');
        field.value = code;
        document.body.append(field);
        field.select();
        document.execCommand('copy');
        field.remove();
      }
      if (label) {
        label.textContent = this.dataset.copiedLabel || original;
        setTimeout(() => { label.textContent = original; }, 2000);
      }
    }, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

if (!customElements.get('s-copy-code')) customElements.define('s-copy-code', CopyCode);
